import myapi from '../../api/index.js'

export default {
  namespaced: true,
  state: {
    oldUrl: '', // 记录上一次页面的地址
    smallBellCount: 0, // 小铃铛的数量
    unreadMessage: 0 // 是否有未读消息
  },
  mutations: {
    // 修改上一次页面的记录
    updateOldUrl: (state, data) => {
      state.oldUrl = data
    },
    // 修改小铃铛数量
    editSmallbellNumber: (state) => {
      myapi.getInformationReadCount().then((res) => {
        if (res.data.code === 200) {
          state.smallBellCount = res.data.data
        }
      })
    },
    // 监控是否有即使通讯消息
    editUnreadMessage: (state) => {
      myapi.unreadMessage().then((res) => {
        if (res.data.code === 200) {
          state.unreadMessage = res.data.data
        }
      })
    },
    // 接受消息更新头部即使通讯消息数目
    updateUnreadMessage: (state, info) => {
      console.log(info)
      if (info.num !== '' && /(^[1-9]\d*$)/.test(info.num)) {
        if (info.type === 'add') {
          state.unreadMessage += info.num
        } else {
          if (state.unreadMessage > info.num || state.unreadMessage === info.num) {
            state.unreadMessage -= info.num
          }
        }
      }
    }
  },
  actions: {
    send: (context, number) => {
      return myapi.send(number)
    },
    register: (context, info) => {
      return myapi.register(info)
    },
    login: (context, info) => {
      return myapi.login(info)
    }
  }
}
